export default __webpack_public_path__ + "static/Matthew-Benyon-51f132e4bad5c5d69f202364144abbfa.png";